document.addEventListener('DOMContentLoaded', () => {
  (() => {
    // Function to replace <br> in innerText with an empty string
    function replaceBrInText(element) {
        if (element && element.innerText.includes('<br>')) {
            element.innerText = element.innerText.replace(/<br>/g, '');
        }
    }
  
    // Function to wait until the .wc_review_count_text element is available
    function waitForElement(node, selector, callback) {
        const checkExist = setInterval(() => {
            const element = node.querySelector(selector);
            if (element) {
                clearInterval(checkExist);
                callback(element);
            }
        }, 100); // Check every 100ms
    }
  
    // MutationObserver to detect when the .wc_overall_review element is added to the DOM
    const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach((node) => {
                    if (node.classList && node.classList.contains('wc_overall_review')) {
                        console.log('wc_overall_review added to DOM');
                        
                        // Wait until .wc_review_count_text is available
                        waitForElement(node, '.wc_review_count_text', (reviewCountElement) => {
                            console.log('wc_review_count_text is now available');
                            console.log(reviewCountElement.innerText);
                            replaceBrInText(reviewCountElement);
  
                            // Observe changes in the text content of reviewCountElement
                            const textObserver = new MutationObserver((mutations) => {
                                mutations.forEach((mutation) => {
                                    if (mutation.type === 'characterData') {
                                        replaceBrInText(reviewCountElement);
                                    }
                                });
                            });
  
                            // Observe the text node for changes
                            const config = { characterData: true, subtree: true };
                            reviewCountElement.childNodes.forEach((childNode) => {
                                if (childNode.nodeType === Node.TEXT_NODE) {
                                    textObserver.observe(childNode, config);
                                }
                            });
                        });
                    }
                });
            }
        });
    });
  
    // Start observing the document body for changes in the DOM after it has loaded
    observer.observe(document.body, { childList: true, subtree: true });
  })();
});
